var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
var DotsContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: absolute;\n    bottom: ", ";\n    left: 50%;\n    transform: translateX(-50%);\n    display: flex;\n    gap: ", ";\n"], ["\n    position: absolute;\n    bottom: ", ";\n    left: 50%;\n    transform: translateX(-50%);\n    display: flex;\n    gap: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.small;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.xxxSmall;
});
var Dot = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background-color: ", ";\n    transition: background-color 0.3s ease;\n"], ["\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background-color: ", ";\n    transition: background-color 0.3s ease;\n"])), function (_a) {
    var isActive = _a.isActive, theme = _a.theme;
    return (isActive ? theme.colors.tfwBlack30 : theme.colors.white);
});
var CarouselDots = function (_a) {
    var _b = _a.totalImages, totalImages = _b === void 0 ? 0 : _b, _c = _a.currentIndex, currentIndex = _c === void 0 ? 0 : _c;
    var visibleDots = 5; // Fixed number of dots to display
    var halfVisibleDots = Math.floor(visibleDots / 2);
    // Calculate the indices represented by the visible dots
    var offset = Math.max(0, Math.min(currentIndex - halfVisibleDots, totalImages - visibleDots));
    return (React.createElement(DotsContainer, null, Array.from({ length: visibleDots }, function (_, idx) {
        var actualIndex = offset + idx; // Map dot to carousel image index
        var isActive = actualIndex === currentIndex;
        return React.createElement(Dot, { key: idx, isActive: isActive });
    })));
};
export default CarouselDots;
var templateObject_1, templateObject_2;
